import { LoaderFunction, redirect } from "react-router-dom";
import { RootState } from "../../store/store";
import { store } from "../../store/store";
import { ROUTES } from "../../utils/constants";
import { verifyUserTokens } from "../../models/authSlice";
import {
  isAllowedBillAuditReturnUrl,
  syncSessionCookieFromStorage,
} from "../../utils/sessionCookie";
import { buildBillAuditReturnUrl } from "../../utils/billAuditSession";

function readStoredAccessToken(): string {
  const raw = localStorage.getItem("edgeProAccessToken");
  if (!raw) return "";
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : String(parsed || "");
  } catch {
    return raw;
  }
}

export const loginLoader: LoaderFunction = async ({ request }) => {
  await store.dispatch(verifyUserTokens());
  syncSessionCookieFromStorage();

  const state: RootState = store.getState();
  const url = new URL(request.url);
  const returnUrl = url.searchParams.get("returnUrl");

  if (state.auth.isAuthenticated) {
    if (returnUrl && isAllowedBillAuditReturnUrl(returnUrl)) {
      const token = readStoredAccessToken();
      return redirect(
        token ? buildBillAuditReturnUrl(returnUrl, token) : returnUrl,
      );
    }
    return redirect(ROUTES.CLAIMS_LIST);
  }
  return null;
};
